import { AddressElement } from '@stripe/react-stripe-js';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';

interface StripeBillingDetailsProps {
  onAddressChange: (event: StripeAddressElementChangeEvent) => void;
}

export const StripeBillingDetails = ({ onAddressChange }: StripeBillingDetailsProps) => {
  return <AddressElement options={{ mode: 'billing' }} onChange={onAddressChange} />;
};
